import { render, staticRenderFns } from "./PaymentOrderRestaurant.vue?vue&type=template&id=d1a14b60"
import script from "./PaymentOrderRestaurant.vue?vue&type=script&lang=js"
export * from "./PaymentOrderRestaurant.vue?vue&type=script&lang=js"
import style0 from "./PaymentOrderRestaurant.vue?vue&type=style&index=0&id=d1a14b60&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports